import query$variables from '@atlassian/jira-relay/src/__generated__/uiExperimentCoordinatorEndOfTrialExtensionQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = { cloudId: string; isTwcJiraTouchPointFix: boolean };

export const endOfTrialExtensionCoordinatorEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "end-of-trial-extension-coordinator" */ './index.tsx'),
	),
	getPreloadProps: ({ cloudId, isTwcJiraTouchPointFix }: EntryPointParams) => ({
		entryPoints: {},
		queries: {
			billingAdminQuery: {
				parameters: query$variables,
				variables: {
					cloudId,
					isTwcJiraTouchPointFix,
				},
			},
		},
	}),
});
